var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex bg-white rounded shadow-hard"},[(_vm.icon)?_c('icon',{staticClass:"pl-3 inline-flex",attrs:{"name":_vm.icon}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }